<template>
  <div class="container">
    <region-install />

    <region-examples />

    <region-props />

    <region-events />
  </div>
</template>

<script>
import RegionInstall from './RegionInstall.vue'
import RegionExamples from './RegionExamples.vue'
import RegionProps from './RegionProps.vue'
import RegionEvents from './RegionEvents.vue'

export default {
  components: {
    RegionInstall,
    RegionExamples,
    RegionProps,
    RegionEvents
  },
  data () {
    return {
      selected: {
        province: '350000',
        city: '350100',
        area: '350104',
        town: '350104008'
      },
      selectedCity: ['110000', '130200', '140100'],
      selectResult: {},
      selectedCityResult: []
    }
  },
  methods: {
    regionChange (d) {
      console.log(d)
    },
    getValue (obj) {
      return obj ? obj.value : ''
    },
    selectLogs (data) {
      if (data) this.selectResult = data
    },
    citySelectedLogs (datas) {
      if (datas && datas.length) this.selectedCityResult = datas
    },
    resultText (region) {
      if (!region || !Object.values(region).some(val => val)) return 'null'
      return Object.values(region).filter(val => val).map(val => val.value).join(',')
    }
  }
}
</script>
